export default "__VITE_ASSET__Cj1OM3fu__"